import { useFieldArray, useFormContext } from "react-hook-form";
import { SingleDaySlices } from "./singleDaySlices";

const DaysAvailability = ({widthClass= " w-full xl:w-1/2 "}) => {

    const {
        control,
    } = useFormContext();


    const {
        fields: daysList,
    } = useFieldArray({
        control,
        name: "days",
    });

    const options = [...Array(25)].map((e, i) => {
        let time = (i < 10 ? '0' : '') + (i < 24 ? i : '00') + ':00';
        return {
            value: i,
            label: time
        }
    });

    return (
        <div className={widthClass}>
            <h2 className="mb-3 text-nt-blue">Business Hours</h2>
            <div className="hidden sm:flex items-center gap-2 mb-1 text-xs text-nt-grey">
                <span className="w-10 shrink-0" />
                <div className="flex flex-1 items-center justify-center min-w-0 gap-1.5">
                    <span className="flex-1 text-center">From</span>
                    <span className="text-nt-grey-light shrink-0">–</span>
                    <span className="flex-1 text-center">To</span>
                    <span className="w-14 shrink-0" aria-hidden="true" />
                    <span className="w-7 shrink-0" aria-hidden="true" />
                </div>
                <span className="w-12 shrink-0 flex flex-col items-center justify-center gap-0.5 text-center" title="Day off">
                    <span className="leading-none text-sm" aria-hidden="true">⛱️</span>
                    <span className="leading-none whitespace-nowrap">Day off</span>
                </span>
            </div>
            <div className="flex flex-col">
                {daysList.map((day, index) => {
                    return <SingleDaySlices options={options} name={day.name} id={index} key={day.id ?? index} />
                })}
            </div>
        </div>
    )
}

export { DaysAvailability }